import React from 'react';
import { HubEmbed } from './_hub-embed/hub-embed';
import './website-builder-content.scss';

type WebsiteBuilderContentProps = {
    hubUrl: string | null;
    hubEmbedRefreshKey: number;
    isHubEmbedRefreshing?: boolean;
};

export const WebsiteBuilderContent = ({
    hubUrl,
    hubEmbedRefreshKey,
    isHubEmbedRefreshing = false,
}: WebsiteBuilderContentProps) => {
    return (
        <div className='website-builder-content'>
            <HubEmbed
                url={hubUrl}
                refreshKey={hubEmbedRefreshKey}
                isRefreshing={isHubEmbedRefreshing}
            />
        </div>
    );
};
